export default "__VITE_ASSET__0yiAf1xY__"